var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1030",
    x: 0,
    y: 0,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-1845 -366)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1845, 366)",
    filter: "url(#Rectangle_1030)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1030-2",
    "data-name": "Rectangle 1030",
    transform: "translate(15 13)",
    fill: "#FF3535",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,0H60a0,0,0,0,1,0,0V60a0,0,0,0,1,0,0H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,.5H59a.5.5,0,0,1,.5.5V59a.5.5,0,0,1-.5.5H5A4.5,4.5,0,0,1,.5,55V5A4.5,4.5,0,0,1,5,.5Z",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M34.3,20.981h-6.53V16.628A3.632,3.632,0,0,0,24.138,13H9.628A3.632,3.632,0,0,0,6,16.628v8.706a3.632,3.632,0,0,0,3.628,3.628h1.451v4.353a.725.725,0,0,0,1.238.513l4.866-4.866h1.151v2.9a3.632,3.632,0,0,0,3.628,3.628h5.5l4.141,4.141a.725.725,0,0,0,1.238-.513V35.491H34.3a3.632,3.632,0,0,0,3.628-3.628V24.608A3.632,3.632,0,0,0,34.3,20.981ZM16.883,27.51a.726.726,0,0,0-.513.213l-3.84,3.84V28.236a.726.726,0,0,0-.726-.726H9.628a2.179,2.179,0,0,1-2.177-2.177V16.628a2.179,2.179,0,0,1,2.177-2.177h14.51a2.179,2.179,0,0,1,2.177,2.177v8.706a2.179,2.179,0,0,1-2.177,2.177Zm19.589,4.353A2.179,2.179,0,0,1,34.3,34.04H32.119a.726.726,0,0,0-.726.726v2.6l-3.115-3.115a.726.726,0,0,0-.513-.213h-5.8a2.179,2.179,0,0,1-2.177-2.177v-2.9h4.353a3.632,3.632,0,0,0,3.628-3.628v-2.9H34.3a2.179,2.179,0,0,1,2.177,2.177Zm-2.9-6.53a.726.726,0,0,1-.726.726h-2.9a.726.726,0,1,1,0-1.451h2.9A.726.726,0,0,1,33.57,25.334Zm0,2.9a.726.726,0,0,1-.726.726H29.217a.726.726,0,0,1,0-1.451h3.628A.726.726,0,0,1,33.57,28.236Zm0,2.9a.726.726,0,0,1-.726.726H23.412a.726.726,0,1,1,0-1.451h9.432A.726.726,0,0,1,33.57,31.138ZM23.412,18.079a.726.726,0,0,1-.726.726H11.079a.726.726,0,1,1,0-1.451H22.687A.726.726,0,0,1,23.412,18.079Zm0,2.9a.726.726,0,0,1-.726.726H11.079a.726.726,0,1,1,0-1.451H22.687A.726.726,0,0,1,23.412,20.981Zm0,2.9a.726.726,0,0,1-.726.726H11.079a.726.726,0,1,1,0-1.451H22.687A.726.726,0,0,1,23.412,23.883Z",
    transform: "translate(1868.902 383.713)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/message-icon.e8b10200add06898e6376cdcbbfbfe16.svg";
export { ForwardRef as ReactComponent };